export default __webpack_public_path__ + "static/media/eye-preview.346281c1.svg";